"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServerSide = isServerSide;

/**
 * Components that depend on specific browser APIs
 * such as `window`, `document`, `Element` will throw
 * errors in a NodeJS (server side) environment
 * because these APIs are unavailable.
 *
 * We should use a guard check to prevent unexpected
 * errors being thrown server-side when trying to
 * render components or invoke methods that reference
 * these unavailable APIs.
 */
function isServerSide() {
  return typeof window === 'undefined';
}